import { Rcm21VersionedService as Rcm21_1_5_0_30 } from "./VersionedOptions/^1.5.0.30/Rcm21VersionedService";
import { Rcm21VersionedService as Rcm21_1_6_0_34 } from "./VersionedOptions/^1.6.0.34/Rcm21VersionedService";
import { Rcm21VersionedService as Rcm21BaseVersionedService } from "./VersionedOptions/^0.0.0.0/Rcm21VersionedService";
export class Rcm21ConfigService extends Rcm21BaseVersionedService {
    constructor() {
        super(...arguments);
        this._services = {
            Rcm21v1_5_0_30: new Rcm21_1_5_0_30(),
            Rcm21v1_6_0_34: new Rcm21_1_6_0_34()
        };
    }
    GetServiceName() {
        return Rcm21ConfigService.ServiceName;
    }
    VersionedConfigurationOptions() {
        return {
            ['^1.5.0.30']: this._services.Rcm21v1_5_0_30,
            ['^1.6.0.34']: this._services.Rcm21v1_6_0_34
        };
    }
}
Rcm21ConfigService.ServiceName = "Rcm21ConfigService";
//# sourceMappingURL=Rcm21ConfigService.js.map